import React from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { leftoverSeriesDossiersToCardsPath } from '../utils/seriesSnapshots';

/**
 * Leftover Series Dossiers door (#696). Not a working room.
 * Lands on Series Notes — the named card, or the pile.
 */
export default function SeriesDossiersPage() {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  return <Navigate to={leftoverSeriesDossiersToCardsPath(projectId, searchParams)} replace />;
}
